import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { formatDateWithProximity } from '../../util/dates';
import css from './TrackingStatus.module.css';

const TrackingEvent = ({ event, intl }) => {
  const { description, event_at, location } = event;
  const dateStr = formatDateWithProximity(new Date(event_at), intl, 'Today');

  return (
    <div className={css.event}>
      <div className={css.eventBullet} />
      <div className={css.eventBody}>
        <div className={css.eventHeader}>
          <span className={css.eventDescription}>{description}</span>
          <span className={css.eventDate}>{dateStr}</span>
        </div>
        {location && <div className={css.eventLocation}>{location}</div>}
      </div>
    </div>
  );
};

const TrackingStatus = props => {
  const { trackingData, intl, className } = props;

  const data = trackingData?.data;
  if (!data) {
    return null;
  }

  const { events, tracking_numbers } = data;
  const firstTracking = tracking_numbers?.[0] || {};
  const { tracking_number, tracking_url } = firstTracking;

  // Use the latest event as current status if available
  const latestEvent = events && events.length > 0 ? events[events.length - 1] : null;

  return (
    <div className={classNames(css.root, className)}>
      <h3 className={css.title}>
        <FormattedMessage id="TrackingStatus.title" defaultValue="Tracking Status" />
      </h3>
      
      {latestEvent && (
        <div className={css.currentStatus}>
          <div className={css.statusLabel}>
            <FormattedMessage id="TrackingStatus.currentStatus" defaultValue="Current Status:" />
          </div>
          <div className={css.statusMessage}>{latestEvent.description}</div>
          {latestEvent.phase && (
            <div className={css.statusDescription}>
              <FormattedMessage id="TrackingStatus.phase" defaultValue="Phase: {phase}" values={{ phase: latestEvent.phase }} />
            </div>
          )}
        </div>
      )}

      {events && events.length > 0 && (
        <div className={css.eventsList}>
          <h4 className={css.eventsTitle}>
            <FormattedMessage id="TrackingStatus.activity" defaultValue="Activity" />
          </h4>
          {[...events].reverse().map((event, index) => (
            <TrackingEvent key={`${event.event_at}-${index}`} event={event} intl={intl} />
          ))}
        </div>
      )}

      {tracking_number && (
        <div className={css.trackingNumberSection}>
          <span className={css.trackingNumberLabel}>
            <FormattedMessage id="TrackingStatus.trackingNumber" defaultValue="Tracking Number:" />
          </span>
          <span className={css.trackingNumberValue}>{tracking_number}</span>
        </div>
      )}

      {tracking_url && (
        <a href={tracking_url} target="_blank" rel="noopener noreferrer" className={css.trackingLink}>
          <FormattedMessage id="TrackingStatus.viewOnSendcloud" defaultValue="View detailed tracking" />
        </a>
      )}
    </div>
  );
};

export default TrackingStatus;
